import { StandaloneAuth } from '@leagueplatform/auth-standalone';
import { getImpersonationType } from '@leagueplatform/auth-utils';
import { endAgentSession, isAgentSession } from 'utils/agent-session';

// The token is the authority while there is one: the SDK reads the agent from
// its claims, and that also covers a member signing in later in a tab that
// still carries a stale agent flag. Without a live session (the banner's
// sign-out is a full page load, and the session may already have lapsed) the
// claims are gone, so the tab flag is the only remaining signal.
const isAgentSignOut = async () => {
  try {
    if (await StandaloneAuth.client.isAuthenticated()) {
      return (await getImpersonationType()) === 'agent';
    }
  } catch {
    // Fall through to the tab flag.
  }
  return isAgentSession();
};

// Shared so the explicit sign-out and the idle-session timeout can't drift.
//
// Members sign out with `federated`, which also ends the upstream IdP session.
// Without it Auth0 clears only its own session and the IdP signs the member
// straight back in.
//
// Support agents sign out without it: they signed in through the support SAML
// provider, not the member's PingID, so there is no member IdP session to end
// and the agent's own support-tool session is left alone.
export const signOut = async () => {
  const isAgent = await isAgentSignOut();
  endAgentSession();
  return StandaloneAuth.client.logout({
    returnTo: window.location.origin,
    federated: !isAgent,
  });
};
